function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  points: "0 0.8841 9.7589 0.8841 9.7589 13.8841 0 13.8841"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "0.0757 0.0004 23.0797 0.0004 23.0797 23 0.0757 23"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.8389,13.3489 C26.7549,12.5439 26.4429,12.5859 26.2479,11.9619 L26.2479,11.0259 C28.3289,11.0199 29.1549,10.3469 29.1549,10.3469 C28.2869,9.8539 28.0119,6.4069 28.0119,6.4069 C28.0119,5.3519 27.5679,4.4079 26.8689,3.7619 C26.6059,3.4559 26.2439,3.2259 25.7769,3.0889 C25.4289,2.9579 25.0539,2.8839 24.6629,2.8839 C24.2469,2.8839 23.8509,2.9679 23.4839,3.1139 C23.1059,3.2379 22.7969,3.4269 22.5569,3.6699 C21.7989,4.3159 21.3139,5.3009 21.3139,6.4069 C21.3139,6.4069 21.0379,9.8539 20.1699,10.3469 C20.1699,10.3469 20.9959,11.0199 23.0769,11.0259 L23.0769,11.9619 C22.9109,12.4949 21.1929,12.5449 19.3969,13.0519 L19.3969,13.7989 C19.5729,14.3649 20.7339,15.1049 22.3179,15.8839 L28.6759,15.8839 C28.9289,15.8839 29.1349,15.6759 29.1349,15.4189 L29.1349,13.7849 C29.1349,13.5909 29.0169,13.4169 28.8389,13.3489",
  fill: "#FEFEFE"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "fam-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M9.7589,11.7991 L9.7589,10.9631 C7.9649,10.2361 6.2589,9.4311 6.0929,8.8991 L6.0929,8.2421 C6.5269,7.7981 6.8689,7.1791 7.0719,6.4531 C7.1489,6.4001 7.2149,6.3331 7.2749,6.2601 C7.2559,6.1531 7.2359,6.0461 7.2359,5.9331 C7.2359,5.6521 7.3049,5.3891 7.4149,5.1521 C7.3759,5.0661 7.3349,4.9821 7.2769,4.9101 L7.2769,3.4411 C7.2769,1.9231 6.4319,0.8841 4.4999,0.8841 C2.6179,0.8841 1.7229,1.9231 1.7229,3.4411 L1.7229,4.9111 C1.5739,5.0931 1.4819,5.3251 1.4819,5.5831 C1.4819,5.9451 1.6579,6.2631 1.9279,6.4521 C2.1299,7.1791 2.4729,7.7981 2.9069,8.2421 L2.9069,8.8991 C2.7129,9.5241 2.3899,10.5281 0.2969,11.3381 C0.1179,11.4071 -0.0001,11.5811 -0.0001,11.7751 L-0.0001,13.4171 C-0.0001,13.6751 0.2059,13.8841 0.4609,13.8841 L6.8349,13.8841 C8.4209,13.1051 9.5829,12.3641 9.7589,11.7991",
  fill: "#FEFEFE",
  mask: "url(#fam-mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "fam-mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("path", {
  d: "M22.5557,18.4944 C18.8517,17.0634 14.7407,15.2864 14.3957,14.1794 L14.3957,13.0174 C15.1627,12.2314 15.7697,11.1364 16.1277,9.8514 C16.6047,9.5174 16.9187,8.9534 16.9187,8.3124 C16.9187,7.8574 16.7537,7.4464 16.4907,7.1234 L16.4907,4.5224 C16.4907,1.8384 14.9957,0.0004 11.5777,0.0004 C8.2487,0.0004 6.6637,1.8384 6.6637,4.5224 L6.6637,7.1234 C6.4017,7.4464 6.2367,7.8574 6.2367,8.3124 C6.2367,8.9524 6.5497,9.5154 7.0267,9.8514 C7.3847,11.1364 7.9917,12.2314 8.7597,13.0174 L8.7597,14.1794 C8.4147,15.2854 4.3037,17.0624 0.5997,18.4944 C0.2847,18.6174 0.0757,18.9244 0.0757,19.2674 L0.0757,22.1734 C0.0757,22.6294 0.4407,23.0004 0.8907,23.0004 L22.2647,23.0004 C22.7147,23.0004 23.0797,22.6294 23.0797,22.1734 L23.0797,19.2674 C23.0797,18.9244 22.8707,18.6164 22.5557,18.4944",
  fill: "#FEFEFE",
  mask: "url(#fam-mask-4)"
}))));

var SvgFamilyService = function SvgFamilyService(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFamilyService, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/family-service.f3dd852a.svg";
export { ForwardRef as ReactComponent };